import React, { Component } from 'react';
import VideoPlayer from '../../components/VideoPlayer';

class SelectedVideoPanel extends Component {
  render() {
    const { video, meta, formatDuration, onMeta, 
      onSplit, onCancel, canCancel, 
      splitting, splitMessage, 
      jobId, jobStatus, handleVideoError ,
      handleDeleteSplit
    
    } = this.props;
    return (
      <div className="selected-area">
        <div className="video-tile video-tile--large selected">
          <VideoPlayer
            key={video.key}
            src={video.url}
            onLoadedMetadata={(e) => onMeta(video.key, e)}
            onError={handleVideoError}
            labelKey={`selected:${video.key}`}
          />
          <div className="meta-badge meta-badge--large">
            {meta ? (
              <>
                <span className="meta-pill">{formatDuration(meta.duration)}</span>
                <span className="meta-dot">•</span>
                <span className="meta-pill">{meta.width}×{meta.height}</span>
              </>
            ) : (
              <span className="meta-pill">Loading info…</span>
            )}
          </div>
        </div>
        <div className="split-actions">
          <button className="split-btn" onClick={onSplit} disabled={splitting}>
            {splitting ? 'Starting…' : 'Split'}
          </button>
          <button
            className="delete-btn"
            onClick={() => handleDeleteSplit()}
            title="Delete this chunk"
          >
            🗑 Delete
          </button>
          {canCancel && <button className="cancel-btn" onClick={onCancel}>Cancel</button>}
          {splitMessage && (
            <span className={`split-msg ${jobStatus === 'failed' ? 'error' : ''}`}>
              {jobId ? `[${jobId}] ` : ''}{splitMessage}
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default SelectedVideoPanel;
